import { Card, Col, Container, Row } from 'reactstrap';
import { PaymentHubFormFieldsData } from '../../loaders/PaymentHubCollectionsWithoutSalenoteData';
import { PaymentHubCollectionsWithoutSalenoteData } from '../loaders/PaymentHubCollectionsWithoutSalenoteData';
import NonSalenotesTable from './NonSalenotesTable';

export const PaymentHubNoSaleNotes = () => {
  return (
    <div className="mx-3 d-flex justify-content-center">
      <PaymentHubFormFieldsData fetchImmediately>
        <PaymentHubCollectionsWithoutSalenoteData fetchImmediately>
          <div className="w-100">
            <Container fluid>
              <Row className="pb-4 gutters-filters">
                <Col xs={12}>
                  <Card>
                    <NonSalenotesTable />
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </PaymentHubCollectionsWithoutSalenoteData>
      </PaymentHubFormFieldsData>
    </div>
  );
};
